import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, toPathString, serializeDataIfNeeded } from '../common.mjs';
import { BASE_PATH } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const UserEmployeeBundleActionControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary 구성원의 인사정보를 조회합니다.
     * @param {UserEmployeeBundleActionControllerApiGetUserEmployeeBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserEmployeeBundle: ({ userIdHash }, options = {}) => {
      assertParamExists("getUserEmployeeBundle", "userIdHash", userIdHash);
      const localVarPath = `/action/v2/core/bundle/user-employees/{userIdHash}/get`.replace(`{${"userIdHash"}}`, encodeURIComponent(String(userIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getUserEmployeeBundle",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @param {UserEmployeeBundleActionControllerApiGetUserEmployeeBundlePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserEmployeeBundlePermissions: ({ userIdHash }, options = {}) => {
      assertParamExists("getUserEmployeeBundlePermissions", "userIdHash", userIdHash);
      const localVarPath = `/action/v2/core/bundle/user-employees/{userIdHash}/get.permissions`.replace(`{${"userIdHash"}}`, encodeURIComponent(String(userIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getUserEmployeeBundlePermissions",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @summary 구성원의 인사정보를 되돌립니다.
     * @param {UserEmployeeBundleActionControllerApiResetUserEmployeeBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    resetUserEmployeeBundle: ({ userIdHash, userEmployeeBundleResetRequest }, options = {}) => {
      assertParamExists("resetUserEmployeeBundle", "userIdHash", userIdHash);
      assertParamExists("resetUserEmployeeBundle", "userEmployeeBundleResetRequest", userEmployeeBundleResetRequest);
      const localVarPath = `/action/v2/core/bundle/user-employees/{userIdHash}/reset`.replace(`{${"userIdHash"}}`, encodeURIComponent(String(userIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userEmployeeBundleResetRequest, localVarRequestOptions, configuration);
      return {
        ...localVarRequestOptions,
        identifier: "resetUserEmployeeBundle",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @summary 구성원의 인사정보를 취소(삭제)합니다.
     * @param {UserEmployeeBundleActionControllerApiRevertUserEmployeeBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revertUserEmployeeBundle: ({ userIdHash, userEmployeeBundleRevertRequest }, options = {}) => {
      assertParamExists("revertUserEmployeeBundle", "userIdHash", userIdHash);
      assertParamExists("revertUserEmployeeBundle", "userEmployeeBundleRevertRequest", userEmployeeBundleRevertRequest);
      const localVarPath = `/action/v2/core/bundle/user-employees/{userIdHash}/revert`.replace(`{${"userIdHash"}}`, encodeURIComponent(String(userIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userEmployeeBundleRevertRequest, localVarRequestOptions, configuration);
      return {
        ...localVarRequestOptions,
        identifier: "revertUserEmployeeBundle",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @param {UserEmployeeBundleActionControllerApiRewriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewrite: ({ userIdHash, userEmployeeBundleRewriteRequest }, options = {}) => {
      assertParamExists("rewrite", "userIdHash", userIdHash);
      assertParamExists("rewrite", "userEmployeeBundleRewriteRequest", userEmployeeBundleRewriteRequest);
      const localVarPath = `/action/v2/core/bundle/user-employees/{userIdHash}/rewrite`.replace(`{${"userIdHash"}}`, encodeURIComponent(String(userIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userEmployeeBundleRewriteRequest, localVarRequestOptions, configuration);
      return {
        ...localVarRequestOptions,
        identifier: "rewrite",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @summary 구성원의 인사정보를 수정합니다.
     * @param {UserEmployeeBundleActionControllerApiUpdateUserEmployeeBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserEmployeeBundle: ({ userIdHash, userEmployeeBundleUpdateRequest }, options = {}) => {
      assertParamExists("updateUserEmployeeBundle", "userIdHash", userIdHash);
      assertParamExists("updateUserEmployeeBundle", "userEmployeeBundleUpdateRequest", userEmployeeBundleUpdateRequest);
      const localVarPath = `/action/v2/core/bundle/user-employees/{userIdHash}/update`.replace(`{${"userIdHash"}}`, encodeURIComponent(String(userIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      localVarHeaderParameter["Content-Type"] = "application/json";
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      localVarRequestOptions.data = serializeDataIfNeeded(userEmployeeBundleUpdateRequest, localVarRequestOptions, configuration);
      return {
        ...localVarRequestOptions,
        identifier: "updateUserEmployeeBundle",
        url: toPathString(localVarUrlObj)
      };
    },
    /**
     * 
     * @param {UserEmployeeBundleActionControllerApiUpdateUserEmployeeBundlePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserEmployeeBundlePermissions: ({ userIdHash }, options = {}) => {
      assertParamExists("updateUserEmployeeBundlePermissions", "userIdHash", userIdHash);
      const localVarPath = `/action/v2/core/bundle/user-employees/{userIdHash}/update.permissions`.replace(`{${"userIdHash"}}`, encodeURIComponent(String(userIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "updateUserEmployeeBundlePermissions",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const UserEmployeeBundleActionControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = UserEmployeeBundleActionControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary 구성원의 인사정보를 조회합니다.
     * @param {UserEmployeeBundleActionControllerApiGetUserEmployeeBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserEmployeeBundle(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getUserEmployeeBundle(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @param {UserEmployeeBundleActionControllerApiGetUserEmployeeBundlePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserEmployeeBundlePermissions(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getUserEmployeeBundlePermissions(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @summary 구성원의 인사정보를 되돌립니다.
     * @param {UserEmployeeBundleActionControllerApiResetUserEmployeeBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    resetUserEmployeeBundle(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.resetUserEmployeeBundle(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @summary 구성원의 인사정보를 취소(삭제)합니다.
     * @param {UserEmployeeBundleActionControllerApiRevertUserEmployeeBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revertUserEmployeeBundle(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.revertUserEmployeeBundle(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @param {UserEmployeeBundleActionControllerApiRewriteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rewrite(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.rewrite(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @summary 구성원의 인사정보를 수정합니다.
     * @param {UserEmployeeBundleActionControllerApiUpdateUserEmployeeBundleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserEmployeeBundle(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.updateUserEmployeeBundle(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    },
    /**
     * 
     * @param {UserEmployeeBundleActionControllerApiUpdateUserEmployeeBundlePermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserEmployeeBundlePermissions(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.updateUserEmployeeBundlePermissions(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
makeRemoteWithOpenapiGenerator({
  requestArgsCreator: UserEmployeeBundleActionControllerApiAxiosParamCreator().getUserEmployeeBundle,
  requestFn: UserEmployeeBundleActionControllerApiFp().getUserEmployeeBundle
});
makeRemoteWithOpenapiGenerator({
  requestArgsCreator: UserEmployeeBundleActionControllerApiAxiosParamCreator().getUserEmployeeBundlePermissions,
  requestFn: UserEmployeeBundleActionControllerApiFp().getUserEmployeeBundlePermissions
});
makeRemoteWithOpenapiGenerator({
  requestArgsCreator: UserEmployeeBundleActionControllerApiAxiosParamCreator().resetUserEmployeeBundle,
  requestFn: UserEmployeeBundleActionControllerApiFp().resetUserEmployeeBundle
});
makeRemoteWithOpenapiGenerator({
  requestArgsCreator: UserEmployeeBundleActionControllerApiAxiosParamCreator().revertUserEmployeeBundle,
  requestFn: UserEmployeeBundleActionControllerApiFp().revertUserEmployeeBundle
});
makeRemoteWithOpenapiGenerator({
  requestArgsCreator: UserEmployeeBundleActionControllerApiAxiosParamCreator().rewrite,
  requestFn: UserEmployeeBundleActionControllerApiFp().rewrite
});
makeRemoteWithOpenapiGenerator({
  requestArgsCreator: UserEmployeeBundleActionControllerApiAxiosParamCreator().updateUserEmployeeBundle,
  requestFn: UserEmployeeBundleActionControllerApiFp().updateUserEmployeeBundle
});
const updateUserEmployeeBundlePermissionsRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: UserEmployeeBundleActionControllerApiAxiosParamCreator().updateUserEmployeeBundlePermissions,
  requestFn: UserEmployeeBundleActionControllerApiFp().updateUserEmployeeBundlePermissions
});

export { UserEmployeeBundleActionControllerApiAxiosParamCreator, UserEmployeeBundleActionControllerApiFp, updateUserEmployeeBundlePermissionsRemote };
//# sourceMappingURL=user-employee-bundle-action-controller-api.mjs.map
